// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"bda63fcc","453":"a1daa14b","686":"7cec010d","787":"8e8aff83"}[chunkId] + ".chunk.js";
};